import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// component edit-report
import {
  getAssessorials,
  getAvailableFilterFields,
} from '../edit-report/helpers';
//////////////////////////////////////////////////

export const getReportFiltersAvailableFields = ({
  reportType,
  filterProps,
  assessorials,
  geoFencingZones,
  disableRefFilter,
  excludedFieldNames,
  allAvailableRefTypesByScopeName,
  fleetDocumentAndCertificationTypes,
}) => {
  const usedReport = { [GC.FIELD_TYPE]: reportType };
  const refList = G.getRefListByReportType(allAvailableRefTypesByScopeName, reportType);

  const availableFields = G.setFilterByParams(
    refList,
    filterProps,
    {
      reportType,
      disableRefFilter,
      fleetDocumentAndCertificationTypes,
      assessorialList: getAssessorials({ assessorials, usedReport }),
    },
  );

  return R.reject(
    ({ value }) => R.includes(value, R.or(excludedFieldNames, [])),
    getAvailableFilterFields({
      usedReport,
      availableFields,
      geoFencingZones,
    }),
  );
};

export const getReportFilterName = (filter, availableFieldsByValue) => {
  if (R.propEq('reference', 'dataType', filter)) {
    return G.getReferenceTitleName(R.pathOr('', [GC.FIELD_REFERENCE_NAME], filter));
  }

  const propertyName = R.prop(GC.FIELD_PROPERTY_NAME, filter);

  return R.pathOr(propertyName, [propertyName, GC.FIELD_NAME], availableFieldsByValue);
};

export const getReportFilterGroups = (filters) => G.mapIndexed(
  (filter, filterIndex) => ({
    filter,
    filterIndex,
    displayGroupId: R.or(
      R.prop(GC.FIELD_GROUP_ID, filter),
      `exact-filter-${filterIndex}`,
    ),
  }),
  R.or(filters, []),
);

export const getFilterPopperSettings = () => ({
  zi: 1300,
  type: 'click',
  usePortal: true,
  overflow: 'unset',
  borderWidth: '1px solid',
  position: 'bottom-start',
  wrapperWidth: 'max-content',
  popperComponentWrapperMargin: '0',
});

export const getWithoutOrGroup = (filter) => R.propOr(
  G.isNilOrEmpty(R.prop(GC.FIELD_GROUP_ID, filter)),
  'withoutOrGroup',
  filter,
);
